import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';

import { AuthService } from '../services/internal';

function cloneWithAuth<TRequest>(req: HttpRequest<TRequest>, token: string): HttpRequest<TRequest> {
    return req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) });
}

export const authInterceptorFn: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);

    let token = authService.getToken();

    if (!token || !authService.getDomainWhitelist().some((domain) => req.url.includes(domain))) {
        return next(req);
    }

    // If the AuthService is not initialized, we cannot refresh the token, so we proceed with the existing token (if any).
    if (!authService.getIsInitialized()) {
        return next(cloneWithAuth(req, token));
    }

    return from(authService.refreshTokenIfExpired()).pipe(
        switchMap((status) => {
            if (status.status === 'SUCCESS') {
                // If the token was successfully refreshed, we use the new token for the request.
                token = status.accessToken;
            } else if (status.status === 'FAILED') {
                console.warn('[AuthInterceptor] Token refresh failed:', status.error);
                authService.logout();
            }

            return next(cloneWithAuth(req, token));
        })
    );
};
